// 全局变量Promise，兼容ie
window.Promise = require('es6-promise');



// 引入样式文件
require('../../static/css/reset.css');
require('../../sass/hotelDetail/hotelDetail.scss');
// 价格日历
require('../../common/hotelCalendarPrice/skin/push-skin.scss');



// 引入各模块 js
require('../../common/layout/header/header').run('noLogin');
require('../../common/layout/footer/footer').run();
require('../../common/sideBar/sideBar').run();



require('./modules/initials.js').run();
require('./modules/hotelInfo.js').run();
require('./modules/searchLine.js').run();
require('./modules/hotelPriceTable.js').run();



//“我的关注”功能
require('../../common/myConcern/myConcern.js');

// 初始化价格日历模块
var y = new Date().getFullYear(),
  m = new Date().getMonth();
require('../../common/hotelCalendarPrice/calendarPrice').run(y, m + 1);


// WEBPACK FOOTER //
// ./src/js/hotelDetail/hotelDetail.js